import Modal from "@modalSrc/Modal";
import { parseSanitizedHtml, sanitizeHtml, sanitizeHtmlDocument } from "@/utils/sanitizeHtml";

type ReportViewModalProps = {
  isOpen: boolean;
  title?: string;
  html?: string;
  onDownloadPdf?: () => void;
  onClose: () => void;
  /** When true, use an iframe so full HTML documents render; otherwise use inline HTML. Default: auto-detect. */
  preferIframe?: boolean;
  /** Stacking order when opening atop another modal (e.g. report definition). */
  zIndex?: number;
};

function looksLikeFullHtmlDocument(h: string): boolean {
  return /^\s*<!DOCTYPE|<\s*html[\s>]/i.test(h);
}

export default function ReportViewModal({
  isOpen,
  title,
  html,
  onDownloadPdf,
  onClose,
  preferIframe,
  zIndex = 1200,
}: ReportViewModalProps) {
  const rawHtml = html?.trim() ? html : "";
  const useIframe =
    preferIframe === true || (preferIframe !== false && looksLikeFullHtmlDocument(rawHtml));
  const h = rawHtml
    ? (useIframe ? sanitizeHtmlDocument(rawHtml) : sanitizeHtml(rawHtml))
    : "";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title || "Report"}
      size="xl"
      className="reportViewModal"
      zIndex={zIndex}
      footer={(
        <>
          <div className="footerLeft">
            {onDownloadPdf ? (
              <button type="button" className="btn btn-secondary" onClick={onDownloadPdf}>Download PDF</button>
            ) : null}
          </div>
          <div className="footerRight">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </>
      )}
    >
      {useIframe ? (
        <iframe className="reportPreviewIframe" title="Report preview" srcDoc={h} sandbox="allow-same-origin" />
      ) : (
        <div className="renderedContent">{parseSanitizedHtml(h)}</div>
      )}
    </Modal>
  );
}
